<template>
    <div class="absolute inset-0 z-50 bg-black/30 rounded-2xl w-full flex justify-center items-center transition-all duration-300">
        <div
            class="w-full h-full lg:w-3/5 lg:h-11/12 flex flex-col items-center justify-between lg:p-5  bg-white rounded-2xl">

            <!-- Logo -->
            <div class="h-2/5 lg:h-3/5 w-full  flex flex-col justify-center items-center border-b lg:border-none border-gray-200 pb-3 lg:pb-0">

                <Vue3Lottie :animationData="options.animationData" :loop="false"
                    class="hidden lg:flex w-full h-full  " />
                <Vue3Lottie :animationData="options.animationDataMobile" :loop="false"
                    class="flex lg:hidden w-full h-fit " />


                    <div class="lg:hidden bg-emerald-500 text-white px-3 py-2 font-medium text-xs rounded mt-3">
                        {{ $t('successful_notification') }}
                    </div>
            </div>

            <!-- Instructions & Spinner -->
            <div class="w-full h-3/5 lg:h-2/5 flex flex-col justify-start space-y-5 items-center bg-slate-50 lg:bg-white rounded-b-lg ">
                <div class="flex flex-col justify-center items-center">
                    <div class="text-gray-600  text-lg font-semibold text-center p-5 lg:p-0">{{
                        $t('oneStep') }}
                    </div>
                    <p class="text-gray-700 font-medium lg:text-sm  text-center ">
                        {{ $t('PaymentMessage') }}
                    </p>
                    <p class="lg:hidden text-gray-600 mt-2 w-3/4 text-sm  text-center ">
                        ({{ $t('SubPaymentMessage') }})
                    </p>
                </div>
                

                <div class="w-full flex justify-center items-start lg:items-center flex-1 ">
                    <CircularCountDown v-if="localTransactionStatus == null" @timeOut="RequestTimedOut">
                    </CircularCountDown>

                    <!-- Loading Animation -->
                    <!-- <transition name="fade-scale">
                        <div v-if="localTransactionStatus == null" class="flex flex-col justify-center items-center">
                            <div class='flex space-x-2 justify-center items-center  h-1/2   w-full'>
                                <div
                                    class='h-3 w-3 bg-[#f01e6b] rounded-full animate-bounceFast [animation-delay:-0.3s]'>
                                </div>
                                <div
                                    class='h-3 w-3 bg-[#f01e6b] rounded-full animate-bounceFast [animation-delay:-0.15s]'>
                                </div>
                                <div class='h-3 w-3 bg-[#f01e6b] rounded-full animate-bounceFast'></div>
                            </div>

                        </div>
                    </transition> -->

                    <!-- Accepted Animation -->
                    <transition name="fade-scale">
                        <div v-if="localTransactionStatus == 'accepted'"
                            class="flex flex-col justify-center items-center">
                            <p class="text-gray-600 text-sm lg:text-lg mb-5 font-semibold text-center p-5 lg:p-0">
                                {{ $t('redirectionS') }}
                            </p>
                            <div
                                class="text-white flex justify-center items-center bg-emerald-500 p-2 rounded-lg space-x-2 animate-bounce">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                                <div> {{ $t('accepted') }}</div>
                            </div>
                        </div>
                    </transition>

                    <!-- Refused Animation -->
                    <transition name="fade-scale">
                        <div v-if="localTransactionStatus == 'refused'"
                            class="flex flex-col justify-center items-center">
                            <p class="text-gray-600 text-sm lg:text-lg mb-5 font-semibold text-center p-5 lg:p-0">
                                {{ $t('redirectionF') }}
                            </p>
                            <div
                                class="text-white flex justify-center items-center bg-red-500 p-2 rounded-lg space-x-2 animate-pulse">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                                <div> {{ $t('refused') }}</div>
                            </div>
                        </div>
                    </transition>


                    <!-- TimedOut Animation -->
                    <transition name="fade-scale">
                        <div v-if="localTransactionStatus == 'timeout'"
                            class="flex flex-col justify-center items-center">
                            <p class="text-gray-600 text-sm lg:text-lg mb-5 font-semibold text-center p-5 lg:p-0">
                                {{ $t('redirectionT') }}
                            </p>
                            <div
                                class="text-white flex justify-center items-center bg-orange-500 p-2 rounded-lg space-x-2 animate-pulse">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                                <div> {{ $t('timeout') }}</div>
                            </div>
                        </div>
                    </transition>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { Vue3Lottie } from 'vue3-lottie'
import animationData from '@/assets/MainGifty.json'
import animationDataMobile from '@/assets/MainGiftyMobile.json'
import { reactive, defineProps, ref, defineEmits, watch } from 'vue'
import CircularCountDown from '../CircularCountDown.vue'

const emit = defineEmits(['removeModal']);


const options = reactive({
    animationData: animationData,
    animationDataMobile: animationDataMobile
})

const props = defineProps({
    transactionStatus: String
})
const localTransactionStatus = ref(props.transactionStatus)


watch(() => props.transactionStatus, (newVal) => {
    localTransactionStatus.value = newVal
})

const RequestTimedOut = () => {
    localTransactionStatus.value = 'timeout';

    setTimeout(() => {
        emit("removeModal");
    }, 3000);
}
</script>

<style>
/* Fade & Scale Transition */
.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-scale-enter-from,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
}
</style>
